import initialState from '../initialState'
import { UPDATE_BINGO_FEED_DATA } from '../actions'

export function updateBingoLobbyFeed (state = initialState.updateBingoLobbyFeed, { type, data }) {
  switch (type) {
    case UPDATE_BINGO_FEED_DATA:
      return {
        ...data
      }
    default:
      return state
  }
}
